export enum ColorGauge {
  PASS = '#1fa00f',
  WARNING = '#daa13e',
  FAIL = '#e34343',
}
